import { TipoPago } from './TipoPago';

// Region codes used in the app: AR -> Aragón, GA -> Galicia
// Keep a default (fallback) rate per TipoPago so existing UI that imports
// `RATES` as a simple map of numbers continues to work.
const DEFAULT_RATES: Record<TipoPago, number> = {
  Internacional: 68.18,
  Nacional: 48.68,
};

// Region-specific overrides. Only regions present here will change the rate;
// otherwise we fall back to DEFAULT_RATES.
const RATES_BY_REGION: Record<TipoPago, Record<string, number>> = {
  Internacional: {
    AR: 68.18, // Aragón
    GA: 68.0, // Galicia
  },
  Nacional: {
    AR: 48.68, // Aragón
    GA: 50.0, // Galicia
  },
};

// Backwards-compatible export: keep `RATES` as a simple mapping used by UI labels.
export const RATES: Record<TipoPago, number> = DEFAULT_RATES;

// Helper to get the appropriate rate given a tipo and optional region code.
export function getRate(tipo: TipoPago, region?: string): number {
  if (region) {
    const byTipo = RATES_BY_REGION[tipo];
    if (byTipo && byTipo[region]) {
      return byTipo[region];
    }
  }
  return DEFAULT_RATES[tipo];
}
